import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const aiPreventionMockTableColumns: ITableColumn[] = [
  {
    labelPath: 'aiPreventionMockPage.tableColumns.name',
    propertyKey: 'name',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'name',
  },
  {
    labelPath: 'aiPreventionMockPage.tableColumns.type',
    propertyKey: 'type',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'type',
  },
  {
    labelPath: 'aiPreventionMockPage.tableColumns.size',
    propertyKey: 'size',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'size',
  },
  {
    labelPath: 'aiPreventionMockPage.tableColumns.createdSentDate',
    propertyKey: 'dateCreatedSent',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'dateCreatedSent',
  },
  {
    labelPath: 'aiPreventionMockPage.tableColumns.ownerCreatedSentBy',
    propertyKey: 'ownerCreatedSentBy',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'ownerCreatedSentBy',
  },
  {
    labelPath: 'aiPreventionMockPage.tableColumns.status',
    propertyKey: 'status',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
    isSortable: true,
    sortKey: 'status',
  },
  {
    labelPath: 'aiPreventionMockPage.tableColumns.agent',
    propertyKey: 'agent',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 30,
    widthType: WidthType.Pixel,
    iconSrc: 'aiServiceIcon',
    isSortable: true,
    sortKey: 'agent',
  },
];
